import './components.scss';
import { NavLink } from "react-router-dom";
import NavigationHeaderItem from './navigationHeaderItem';
import { useCart } from '../../context/CartContext';

const NavigationHeader = () => {
  const { cartCount } = useCart();
  return (
    <>
      <div className="navigationHeader">
        <div className='test'>
          <NavLink to="/" className='navigationHeaderLink'>
            <img src={require("../../images/site/dbs.png")} alt="" />
          </NavLink>
        </div>
        <li>
          <NavLink to="/" end className='navigationHeaderLink'>
            <NavigationHeaderItem name="home"/>
          </NavLink>
        </li>
        <li>
          <NavLink to="/shop" className='navigationHeaderLink'>
            <NavigationHeaderItem name="shop"/>
          </NavLink>
        </li>
        <li>
          <NavLink to="/nail-mail" className='navigationHeaderLink'>
            <NavigationHeaderItem name="nail mail"/>
          </NavLink>
        </li>
        <li>
          <NavLink to="/cart" className='navigationHeaderLink cartLink'>
            <NavigationHeaderItem name={`cart${cartCount > 0 ? ` (${cartCount})` : ''}`}/>
          </NavLink>
        </li>
      </div>
      <div className="marqueeBar">
        <div className="marqueeContent">
          <span>✧･ﾟ: *✧･ﾟ:*</span>
          <span>free shipping on orders above $50</span>
          <span>✧･ﾟ: *✧･ﾟ:*</span>
          <span>only shipping to US</span>
          <span>✧･ﾟ: *✧･ﾟ:*</span>
          <span>free shipping on orders above $50</span>
          <span>✧･ﾟ: *✧･ﾟ:*</span>
          <span>only shipping to US</span>
        </div>
      </div>
    </>
  )
}

export default NavigationHeader;
